<template>
  <ColumnFieldSelect
    v-for="field in fields"
    :key="field.key"
    :field="field"
    :value="values[field.key] ?? ''"
    :enabled-values="availability[field.key]"
    @update="(value) => emit('update', field.key, value)"
  />
</template>

<script setup lang="ts">
import type { FieldAvailability } from '../column-constraints'
import type { ColumnValues, FieldSchema } from '../types'
import ColumnFieldSelect from './column-field-select.vue'

// A run of selects over one slice of a column's schema. The caller owns the
// layout it sits in (a grid, an operand card) and hears back which field
// changed.
//
// The presenter ships a value for every field its type's schema lists, so the
// `?? ''` below is a type-level fallback rather than a state the drawer shows.
//
// `availability` covers the whole column, not just this slice: which values a
// field may take depends on values the user may be looking at in another group
// (a difference operand narrows the basis above it), so it is computed once for
// the column and read per field here.
defineProps<{
  fields: FieldSchema[]
  values: ColumnValues
  availability: FieldAvailability
}>()

const emit =
  defineEmits<{
    update: [key: string, value: string]
  }>()
</script>
